'use strict';

var React = require('react');

module.exports = React.createClass({
	displayName: 'Accesskeys',

	_onClickHandler: function() {
		document.getElementById('svtse_accessKey--s').focus();
	},

	render: function() {

		var clickHandler = this._onClickHandler;

		return (
			<div className="svtse_accesskeys">
				<a className="svtse_accesskeys__link-visible" title="Gå direkt till innehållet" href="#svtse_accessKey--s" accessKey="s" onClick={clickHandler} tabIndex="0">Gå direkt till textinnehållet</a>
				<a className="svtse_accesskeys__link" title="Startsida" href="/" accessKey="1" tabIndex="-1">Startsida</a>
				<a className="svtse_accesskeys__link" title="Innehållsöversikt, Program A-Ö" href="http://www.svt.se/program/" accessKey="3" tabIndex="-1">Innehållsöversikt, Program A-Ö</a>
				<a className="svtse_accesskeys__link" title="Sök på svt.se" href="#svtse_accessKey--4" accessKey="4" tabIndex="-1">Sök på svt.se</a>
				<a className="svtse_accesskeys__link" title="Hjälp" href="http://www.svt.se/tittarservice" accessKey="6" tabIndex="-1">Hjälp</a>
				<a className="svtse_accesskeys__link" title="Kontakta oss" href="http://www.svt.se/tittarservice" accessKey="7" tabIndex="-1">Kontakta oss</a>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/accesskeys/Accesskeys.jsx
 **/